import config from '@/utils/config'

/**
 * Replaces Firebase storage URLs with the configured CDN URL
 * @param {string} url - The original Firebase URL
 * @returns {string} - The URL with the Firebase storage part replaced with CDN URL
 */
export const replaceWithCdnUrl = (url) => {
  if (!url) return url

  const cdnUrl = config('MEDIA_CDN_URL')
  return url.replace(
    /https:\/\/firebasestorage\.googleapis\.com\/v0\/b\/[^/]+\/o/,
    cdnUrl
  )
}
